// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>19</span>&nbsp;&nbsp;Arise, O Lord, and let not mortals have the upper hand;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;let the nations be judged before your face.<br> </p> </div></div>";
// Exports
module.exports = code;